

export const frontMatter = {
	sidebar_position: 8
};
export const contentTitle = 'Простая грамматика';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-ru-docusaurus-plugin-content-docs-current-learn-simple-grammar-index-md-926.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    header: "header",
    li: "li",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, DocCardList} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!DocCardList) _missingMdxReference("DocCardList", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "простая-грамматика",
        children: "Простая грамматика"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Упрощенная грамматика, или ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), ", представляет собой сильно упрощенную форму межславянского языка, которая позволяет неславянским людям выражать свои мысли на самом базовом уровне при посещении славянских стран или поддержании контактов со славянами через Интернет. Грамматика сведена к минимуму, а формы, которые не являются строго необходимыми, вообще не используются. Поскольку он не содержит ничего такого, чего нельзя было бы найти в славянских языках, результат не будет выглядеть или звучать слишком неловко для носителей славянского языка, а скорее напомнит им язык, которым пользуются маленькие дети."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " также можно использовать в качестве первого шага в процессе изучения «настоящего» межславянского языка. Он построен таким образом, что его можно постепенно расширять новыми деталями, которые встречаются в более сложных версиях. Таким образом, мы выделяем три разных уровня, каждый из которых добавляет новые элементы, приближающие ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " к межславянскому:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Уровень 1"
        }), " – самый простой уровень: без рода, без падежей, только единственное/множественное число, одно глагольное окончание в каждом времени."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Уровень 2"
        }), " – введение в род, простая модель спряжения глаголов (присутствует во всех славянских языках)"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Рабочее название ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " представляет собой слово-портманто, обозначающее «славянский эсперанто». Это имя, хотя и несколько насмешливое, указывает на простоту ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), ": у него нет рода, падежей, аспектов, небольшого спряжения и неправильности. Однако на этом сходство с эсперанто заканчивается, поскольку средства упрощения ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " на самом деле гораздо больше похожи на те, которые используются ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Interlingua"
      }), "."]
    }), "\n", _jsx(DocCardList, {}), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

